import React from "react";
const getComponentDefaultValue = () => React.createElement(React.Fragment, null);
const getNavLinkDefaultValue = (props) => (React.createElement(React.Fragment, null, props.children));
const getOpenEarlyExitTagModalDefaultValue = () => undefined;
const createDefaultContext = () => ({
    getIcon: getComponentDefaultValue,
    dictionary: {},
    getNavLink: getNavLinkDefaultValue,
    openEarlyExitTagModal: getOpenEarlyExitTagModalDefaultValue
});
export const defaultValue = createDefaultContext();
export const SportsbookContext = React.createContext(createDefaultContext());
//# sourceMappingURL=SportsbookContext.js.map